export class Destination {
    constructor() {
        this.UbicationId = "";
        this.UbicationType = null;
        this.LocationId = "";
        this.Name = "";
        this.AddressType = "";
        this.Address = "";
        this.AddressNumber = "";
        this.PostalCode = "";
        this.ProvinceCode = "";
        this.ProvinceName = "";
        this.PoblationCode = "";
        this.CountryCode = "";
        this.MunicipalityCode = "";
    }
}